import ConnectWithoutContactRoundedIcon from "@mui/icons-material/ConnectWithoutContactRounded";
import NewReleasesRoundedIcon from "@mui/icons-material/NewReleasesRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import FeedbackRoundedIcon from "@mui/icons-material/FeedbackRounded";
import Diversity1RoundedIcon from "@mui/icons-material/Diversity1Rounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";

export const experienceArray = [
  {
    icon: (
      <ConnectWithoutContactRoundedIcon
        color="success"
        fontSize="large"
        sx={{ width: "100%" }}
      />
    ),
    text: "Spearheaded the development of critical product features from initial concept through to successful release, maintaining consistent communication with product managers and key stakeholders throughout the process.",
  },
  {
    icon: (
      <NewReleasesRoundedIcon
        color="success"
        fontSize="large"
        sx={{ width: "100%" }}
      />
    ),
    text: "Led cross-functional collaboration, analyzed feature performance post-release, and synthesized user and stakeholder feedback to drive continuous improvement.",
  },
  {
    icon: (
      <AssignmentRoundedIcon
        color="success"
        fontSize="large"
        sx={{ width: "100%" }}
      />
    ),
    text: "Translated product requirements into actionable tasks for the development team, providing clear guidance and technical support throughout the development lifecycle.",
  },
  {
    icon: (
      <FeedbackRoundedIcon
        color="success"
        fontSize="large"
        sx={{ width: "100%" }}
      />
    ),
    text: "Contributed to the company’s Site Reliability Engineering (SRE) collaboration guild by developing and refining monitoring and alerting systems, enhancing observability to proactively detect and resolve potential system failures.",
  },
  //__________
  {
    icon: (
      <Diversity1RoundedIcon
        color="success"
        fontSize="large"
        sx={{ width: "100%" }}
      />
    ),
    text: "Founded and chaired the company’s first Employee Resource Group (ERG), aligning initiatives with the company’s mission to promote diversity, equity, and inclusion (DEI).",
  },
  {
    icon: (
      <CalendarMonthRoundedIcon
        color="success"
        fontSize="large"
        sx={{ width: "100%" }}
      />
    ),
    text: "Designed, led, and executed company-wide events focused on cultural awareness, professional development, and social impact, boosting employee engagement and DEI awareness.",
  },
];
